// ===================================================
// LISTA DE COMPRAS
// ===================================================
const COMPRA_STATUS={necessidade:'Necessidade',cotando:'Em cotação',aprovado:'Aprovada',pedido_enviado:'Pedido enviado',aguardando_entrega:'Aguardando entrega',recebido_parcial:'Recebida parcialmente',recebido_total:'Recebida',lancado_estoque:'Lançada no estoque',cancelado:'Cancelada'};
const COMPRA_ORIGEM={pedido:'Pedido / obra',medicao:'Medição',plano_corte:'Plano de corte',estoque_minimo:'Estoque mínimo',manual:'Compra manual'};
function compraNorm(v=''){return String(v).normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim().toLowerCase().replace(/\s+/g,' ')}
function compraChave(material,espessura='',tipo='',comp=0,larg=0,lote=''){return[compraNorm(material),String(espessura||''),compraNorm(tipo),Number(comp||0),Number(larg||0),compraNorm(lote)].join('|')}
function compraValor(c){return Math.round(((geoNum(c.precoM2)*geoNum(c.m2Comprar||c.m2Necessario))+geoNum(c.frete))*100)/100}
function estoqueCompraExato(material,espessura){return DB.get('estoque').find(e=>compraNorm(e.material)===compraNorm(material)&&String(e.espessura||'').replace(/[^\d.,]/g,'').replace(',','.')===String(espessura||'').replace(/[^\d.,]/g,'').replace(',','.'))}

function comprasNecessidadesCalculadas(){
  // Build purchase list: pedidos in active statuses with material field
  const pedidos = DB.get('pedidos').filter(p=>!['cancelado','pago','entregue'].includes(p.status));
  const necessidades = {};
  const medicoes = DB.get('medicoes');
  function addNecessidade(material,area,pedido,peca={}){
    const esp=String(peca.espessura||peca.esp||pedido.espessura||'2').replace(/[^\d.,]/g,'').replace(',','.')||'2';
    const tipo=peca.tipoMaterial||peca.tipo||'';
    const chave=compraChave(material,esp,tipo);
    if(!compraNorm(material)||!(area>0))return;
    if(!necessidades[chave])necessidades[chave]={chave,material:String(material).trim(),espessura:esp,tipo,pedidos:[],m2Necessario:0,origem:'pedido'};
    necessidades[chave].pedidos.push({id:pedido.id,num:pedido.num||pedido.id.slice(-4),cliente:pedido.cliente,ambiente:peca.ambiente||'',area,status:SL[pedido.status]||pedido.status});
    necessidades[chave].m2Necessario+=area;
  }
  pedidos.forEach(p=>{
    // 1. Use medição linked to this pedido (most accurate — uses consumoM2 with geometry)
    const med=p.medicaoId?medicoes.find(m=>m.id===p.medicaoId):null;
    if(med&&(med.ambientes||[]).length){
      med.ambientes.forEach(amb=>(amb.pecas||[]).forEach(peca=>{
        const mat=String(peca.material||'').trim();if(!mat)return;
        const area=Number(peca.consumoM2)||areaMedPeca(peca);
        addNecessidade(mat,area,p,{...peca,ambiente:amb.nome});
      }));
      return;
    }
    // 2. Pedido itens — use consumoM2 if set, else simple comp×larg
    const itens=(p.itens||[]).filter(it=>it.material&&(it.comp||it.consumoM2));
    if(itens.length){
      itens.forEach(it=>addNecessidade(it.material,Number(it.consumoM2)||((Number(it.comp)/100)*(Number(it.larg)/100)*(Number(it.qtd)||1)),p,it));
      return;
    }
    // 3. Fallback: pedido.material + pedido.area
    if(p.material&&p.area) addNecessidade(p.material,Number(p.area),p);
  });

  // Reposição independente de obra: cada combinação exata de material e
  // espessura abaixo do mínimo gera sua própria necessidade.
  DB.get('estoque').filter(e=>geoNum(e.disponivelM2)<geoNum(e.minimoM2)).forEach(e=>{
    const base=compraChave(e.material,e.espessura,e.tipo),chave=base+'|estoque_minimo';
    if(!necessidades[chave])necessidades[chave]={chave,material:e.material,espessura:String(e.espessura||'2').replace(/[^\d.,]/g,'').replace(',','.'),tipo:e.tipo||'',pedidos:[],m2Necessario:Math.max(0,geoNum(e.minimoM2)-geoNum(e.disponivelM2)),origem:'estoque_minimo'};
  });

  Object.values(necessidades).forEach(nec=>{
    const estoq=estoqueCompraExato(nec.material,nec.espessura);
    const dispM2 = estoq?.disponivelM2||0;
    const falta = Math.max(0, nec.m2Necessario - dispM2);
    const chapa=(estoq?.chapas||[]).find(c=>c.status==='disponivel')||{};
    const comp=geoNum(chapa.comp||chapa.comprimento)||320,larg=geoNum(chapa.larg||chapa.largura)||180,chapaM2=comp*larg/10000;
    Object.assign(nec,{disponivelM2:dispM2,m2Faltante:falta,folga:10,m2Comprar:Math.ceil(falta*1.1*100)/100,chapaComp:comp,chapaLarg:larg,qtdChapas:falta>0?Math.ceil((falta*1.1)/chapaM2):0,fornecedor:estoq?.fornecedor||'',estoqueId:estoq?.id||'',ok:falta<=0});
  });
  return Object.values(necessidades);
}

function compraRegistroDaNecessidade(n){return DB.get('compras').find(c=>c.necessidadeChave===n.chave&&!['cancelado','lancado_estoque'].includes(c.status))}
function materialSuficienteCard(n){return`<div class="panel" style="padding:12px;margin-bottom:8px"><strong>${escapeHtml(n.material)}</strong> · ${escapeHtml(n.espessura)} cm <span class="badge b-aprovado">Estoque atende</span><div class="muted" style="font-size:12px">Necessário ${n.m2Necessario.toFixed(2)} m² · Disponível ${n.disponivelM2.toFixed(2)} m² · reservar para ${n.pedidos.length} pedido(s)</div></div>`}

